module.exports = __webpack_public_path__ + "img/avatar-10.1c98df50.jpeg";